export function bangbang(x) {
    let result = 1;
    if (x === 0 || x === -1)
        return result;
    const x2 = x / 2;
    for (let index = 0; index < x2; index++) {
        result *= x;
        x -= 2;
    }
    return result;
}
export function eliptical(k) {
    let temp = 1;
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    for (let n = 1; n <= 20; n = n + 1) {
        const a = 2 * n - 1;
        const b = 2 * n;
        const fa = bangbang(a);
        const fb = bangbang(b);
        temp = temp + Math.pow(fa / fb, 2) * Math.pow(k, b);
    }
    return (Math.PI * temp) / 2;
}
// TODO: determine if these can be safely replaced by corresponding mathjs functions
export function tanh(x) {
    return (Math.exp(2 * x) - 1) / (Math.exp(2 * x) + 1);
}
export function coth(x) {
    return (Math.exp(2 * x) + 1) / (Math.exp(2 * x) - 1);
}
export function sech(x) {
    return 2 / (Math.exp(x) + Math.exp(-x));
}
//# sourceMappingURL=mathHelpers.js.map